<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss`">社会服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss/expert`">专家</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div v-loading="loading" class="g-content mentor-content">
        <div class="card">
          <div class="avatar">
            <img @error="imgError" class="avatar_img" :src="data.Photo" :alt="data.Name" />
          </div>
          <div class="right">
            <h3>{{ data.Name }}</h3>
            <p>
              <span>所属学院：{{ data.College }}</span>
              <span>学历:{{ data.Education }}</span>
              <span>职称：{{ data.ProfessionalTitle }}</span>
            </p>
          </div>
          <div v-if="$store.getters.setChatText" class="chat">
            <div class="btn">
              <a @click="expertChat">在线咨询</a>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <column-header2 :data="{ name: '擅长领域' }"></column-header2>
          <div class="content">{{ data.Expertise }}</div>
          <column-header2 :data="{ name: '个人简介' }"></column-header2>
          <div class="content">{{ data.Introduce }}</div>
        </div>
      </div>
    </div>
    <el-dialog title="在线咨询" :visible.sync="dialogVisible" top="80px" :before-close="handleClose">
      <div class="expert-dialog">
        <iframe id="iframe" :src="goUrl" frameborder="0" class="frame-container"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDetail } from "api/app";
import { createDialog } from "api/chat";
import ColumnHeader from "_c/ColumnHeader2";
import Mgr from "@/services/SecurityService";
export default {
  data() {
    return {
      data: {},
      UserId: "",
      loading: "",
      goUrl: "",
      userMgr: new Mgr(),
      dialogVisible: false
    };
  },
  created() {
    this.goUrl = `https://recruit.ve-city.com/chat?inset=recruitNav`;
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  methods: {
    loadData() {
      getDetail({ name: "SchoolExpert", id: this.$route.params.id }).then(
        res => {
          this.UserId = res.Id;
          this.data = res || {};
        }
      );
    },
    init() {
      this.loadData();
    },
    async expertChat() {
      var isLogin = this.userMgr.isLogin();
      this.isLogin = isLogin;
      if (this.isLogin) {
        await this.$store.dispatch("user/getInfo");
        if (this.$store.getters.token) {
          this.loading = true;
          createDialog({ expertId: this.UserId })
            .then(res => {
              if (res.IsSuccess) {
                this.goUrl += "&chats=hide&ChatId=" + res.Result;
                this.dialogVisible = true;
              } else {
                this.$message.error(res.Message);
              }
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
        } else {
          this.$confirm("请登录", { type: "warning" })
            .then(() => {
              this.userMgr.signIn();
            })
            .catch(err => console.log(err));
        }
      } else {
        this.$confirm("请登录", { type: "warning" })
          .then(() => {
            this.userMgr.signIn();
          })
          .catch(err => console.log(err));
      }
    },
    handleClose(done) {
      this.$confirm("是否关闭聊天？", { type: "warning" })
        .then(() => {
          this.goUrl = `https://recruit.ve-city.com/chat?inset=recruitNav`;
          done();
        })
        .catch(() => { });
    }
  }
};
</script>

<style lang="scss" scoped>
// /deep/ .el-dialog {
//   background: rgba(204, 204, 204, 0.027);
//   .el-dialog__close,
//   .el-dialog__title {
//     color: #fff;
//   }
//   .el-dialog__body {
//     padding-bottom: 0px;
//   }
// }
// .expert-dialog {
//   height: calc(100vh - 90px);
//   width: 100%;
//   // background: #fff;
//   display: flex;
//   justify-content: center;
// }
.el-dialog__wrapper,
/deep/ .el-dialog {
  min-width: 720px;
}
.chat-dialog {
  min-width: 700px;
}
.frame-container {
  width: 100%;
  height: calc(100vh - 240px);
  background: #fff;
  border: none;
  position: relative;
}
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  .mentor-content {
    padding: 0 0 40px 0;
    .card {
      background: url(~assets/img/feature/watermarker.png) no-repeat #5463a4 95%
        top;
      background-size: 170px auto;
      border-radius: 8px 8px 0 0;
      color: #fff;
      height: 102px;
      padding: 16px 40px;
      display: flex;
      align-items: center;
      .avatar {
        width: 104px;
        height: 104px;
        margin-right: 24px;
        .avatar_img {
          border-radius: 52px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h3 {
          font-size: 20px;
          font-weight: 500;
          padding-bottom: 8px;
        }
        p {
          width: 760px;
          display: flex;
          flex-wrap: wrap;
          line-height: 22px;
          span {
            width: 33%;
          }
        }
      }
      .chat {
        .btn {
          a {
            width: 88px;
            height: 32px;
            border-radius: 20px;
            border: 1px solid $primary-color;
            color: $primary-color;
            background-color: #fff;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-left: 8px;
          }
        }
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 168px;
    }
  }
}
</style>
